<template>
    <div>
        <!--<h5>Assign Users and Teams on Areas</h5>-->
        <v-offline online-class="online" offline-class="offline" @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>
        <div v-if="!embedded" class="row">
            <div class="col-6">
                <h5 class="set_font_title">Assigned Users</h5>
            </div>
            <div class="col-6 text-right">
                <button v-if="!isReadOnly" class="btn btn-primary" @click="$router.push({ name: 'mvAssignUser' })">
                    <i class="fa fa-plus"></i> Assign User
                </button>
            </div>
        </div>
        <hr v-if="!embedded">
        <div :class="embedded ? '' : 'card row'">
            <div :class="embedded ? '' : 'card-body col-sm-12 col-xl-12'">
                <table id="assignedUsers" class="display table-striped table-bordered select" cellspacing="0"
                    width="100%">
                    <thead>
                        <tr>
                            <th>User</th>
                            <th>Role</th>
                            <th>Area</th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import VOffline from 'v-offline';
import mixin from '../../../../mixins/GlobalMixin';

export default {
    mixins: [mixin],
    watch: {
        dialogVisible(newValue) {
            if (newValue === false) {
                this.init();
            }
        }
    },
    components: {
        VOffline
    },
    props: {
        projectId: {
            type: Number,
        },
        embedded: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isReadOnly: false,
            table: null,
            onLine: true,
            wasOffline: false,
            onlineSlot: 'online',
            offlineSlot: 'offline',
        }
    },
    methods: {
        async init() {
            await this.$store.dispatch("setScreenName", "Assigned Users");
            this.getAssignedUsers();
        },

        getAssignedUsers() {
            let vm = this;

            if (vm.table != null) {
                vm.table.destroy();
            }
            try {
                vm.table = $('#assignedUsers').DataTable({
                    "order": [[1, "desc"]],
                    "scrollX": true,
                    responsive: true,
                    dom: 'lBfrtip',
                    "bInfo": false,
                    'columns': [
                        // {
                        // 0 index for assinged user id
                        //     'targets': 0,
                        //     'render': function (data, type, full, meta) {
                        //         return full[0];
                        //     }
                        // }, 
                        {
                            'targets': 1,
                            'render': function (data, type, full, meta) {
                                return full[1];
                            }
                        }, {
                            'targets': 2,
                            'render': function (data, type, full, meta) {
                                return full[2];
                            }
                        }, {
                            'targets': 3,
                            'render': function (data, type, full, meta) {
                                return full[3];
                            }
                        }
                        // , {
                        // 4 index for assigned area (primary key)
                        //     'targets': 4,
                        //     'render': function (data, type, full, meta) {
                        //         return full[4];
                        //     }
                        // }
                    ],
                    buttons: [
                        {
                            extend: 'excel',
                            text: 'Export to excel',
                            className: 'btn btn-default',
                            exportOptions: {
                                columns: [0, 1, 2, 3, 4],
                            }
                        },
                        {
                            extend: 'colvis',
                            text: 'Filter Columns',
                            className: 'btn btn-default'
                        }
                    ],
                    "processing": true,
                    "serverSide": true,
                    "ajax": {
                        "url": `${window.DATATABLES_BASE_URL}mv/assigned/field/users`,
                        "type": "POST",
                        "data": {
                            project_id: vm.projectId,
                        }
                    },
                    lengthMenu: [[15, 100, -1], [15, 100, "All (Warning: Slow)"]],
                    pageLength: 15,
                });
            } catch (e) {
                console.log(e)
            }
        }

    },
    mounted() {
        this.init();
        let vm = this;
        vm.isReadOnly = false;
        vm.$store.getters.getUserRoleForCurrentProject.forEach(r => {
            if (r.role_name == 'VIEWER') {
                vm.isReadOnly = true;
            }
        });
    }
}


</script>
<style scoped>
.set_font_title {
    font-size: 20px;
    font-weight: 600;
    color: black;
}

.fa {
    margin: 0;
}
</style>
